import { cn } from '@seen/ui'
import type { ComponentPropsWithoutRef, JSX } from 'react'

export type FacesheetCardActionsProps = ComponentPropsWithoutRef<'div'>

// Right cluster of a card's header row — count, add, print/edit/history —
// pushed to the far edge by FacesheetCardHeader's justify-between.
export function FacesheetCardActions({
  className,
  ...delegated
}: FacesheetCardActionsProps): JSX.Element {
  return (
    <div
      className={cn('flex shrink-0 items-center gap-1.5', className)}
      {...delegated}
    />
  )
}
